import { phoneRegExp, regexEmail, regexPassword } from 'common/constants';
import * as yup from 'yup';
import { QuestionType } from 'pages/admin/campaign-overview/constants';
// import { toast } from 'react-toastify';

const schemaTextValidate = {
    required: {
        default: 'Vui lòng nhập',
        choice: 'Vui lòng chọn',
        termAndConditions: 'Vui lòng đồng ý với điều khoản và điều kiện',
        receiveEmail: 'Vui lòng đồng ý nhận tin tức qua email',
        question: 'Vui lòng nhập nội dung câu hỏi',
    },
    format: {
        email: 'Email không hợp lệ, vui lòng thử lại',
        password:
            'Mật khẩu phải có ít nhất 6 ký tự, bao gồm ít nhất một chữ cái, một số và một ký tự đặc biệt',
        sameAsCurrentPassword:
            'Mật khẩu mới không được giống mật khẩu hiện tại',
        confirmPassword: 'Nhập lại mật khẩu không đúng.',
        max: (max: number) => `Tối đa ${max} ký tự`,
        date: 'Định dạng ngày không hợp lệ',
    },
    campaign: {
        date: 'Vui lòng chọn thời gian đến ngày của chiến dịch lớn hơn bằng hiện tại',
    },
    campaignOverview: {
        numberOfRows: 'Số hàng phải lớn hơn 0',
        numberOfColumns: 'Số cột phải lớn hơn 0',
    },
};

const schemaTextValidateLogin = {
    format: {
        fileRequired: 'Vui lòng chọn file',
        fileType: 'File tải nên không đúng định dạng, vui lòng tải lại',
        fileSize: 'Vui lòng tải file không quá 5MB',
        fileNameSpecialCharacters: 'Tên file không hợp lệ',
    },
};

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
const FILE_SIZE_LIMIT = 5 * 1024 * 1024;
const FILE_SIZE_LIMIT_20 = 20 * 1024 * 1024;

export const loginSchema = yup.object().shape({
    rememberMe: yup.boolean(),
    email: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexEmail, schemaTextValidate.format.email),
    password: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexPassword, schemaTextValidate.format.password),
});

export const registerAdminSchema = yup.object().shape({
    email: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexEmail, schemaTextValidate.format.email),
    password: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexPassword, schemaTextValidate.format.password),
    password_confirmation: yup
        .string()
        .required(schemaTextValidate.required.default)
        .oneOf(
            [yup.ref('password')],
            schemaTextValidate.format.confirmPassword
        ),
    termsAndConditions: yup
        .boolean()
        .oneOf([true], schemaTextValidate.required.termAndConditions),
    receiveEmail: yup.boolean(),
});

export const registerAdminCreatePasswordSchema = yup.object().shape({
    password: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexPassword, schemaTextValidate.format.password),
    password_confirmation: yup
        .string()
        .required(schemaTextValidate.required.default)
        .oneOf(
            [yup.ref('password')],
            schemaTextValidate.format.confirmPassword
        ),
});

export const forgotPasswordSchema = yup.object().shape({
    email: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexEmail, schemaTextValidate.format.email),
});

export const headerSearchInputSchema = yup.object().shape({
    searchKeyWord: yup.string(),
    status: yup.array(),
    campaignType: yup.array(),
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
});
export const paymentFilterSchema = yup.object().shape({
    searchKeyWord: yup.string(),
    status: yup.array(),
    paymentType: yup.array(),
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
});

export const resetPasswordSchema = yup.object().shape({
    password: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexPassword, schemaTextValidate.format.password),
    password_confirmation: yup
        .string()
        .required(schemaTextValidate.required.default)
        .oneOf(
            [yup.ref('password')],
            schemaTextValidate.format.confirmPassword
        ),
});

export const campaignSchema = yup.object().shape({
    kind: yup.string().required(schemaTextValidate.required.choice),
    title: yup
        .string()
        .max(500, schemaTextValidate.format.max(500))
        .required(schemaTextValidate.required.default),
    // admin_id: yup.string().required(schemaTextValidate.required.choice),
    admin_id: yup.string(),
    public_date: yup.string().required(schemaTextValidate.required.default),
    close_date: yup.string().required(schemaTextValidate.required.default),
    description: yup.string().required(schemaTextValidate.required.default),
    secure_type: yup.string().required(schemaTextValidate.required.choice),
    import_question: yup.boolean(),
    enable_minimum_answer_time: yup.boolean(),
    is_required_location: yup.boolean(),
    is_public_preview: yup.boolean(),
    is_multiple_answer: yup
        .boolean()
        .required(schemaTextValidate.required.choice),
    minimum_answer_time: yup
        .number()
        .nullable()
        .typeError('Thời gian phải là số')
        .when('enable_minimum_answer_time', {
            is: true,
            then: (schema) =>
                schema
                    .required(schemaTextValidate.required.default)
                    .min(
                        0,
                        'Thời gian trả lời tối thiểu phải lớn hơn hoặc bằng 0'
                    ),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),
    file: yup
        .mixed()
        .nullable()
        .test(
            'is-required',
            schemaTextValidateLogin.format.fileRequired,
            function (value) {
                const { import_question } = this.parent;
                if (import_question && !value) {
                    return false;
                }
                return true;
            }
        )
        .test('fileName', 'Tên file không hợp lệ', function (value) {
            const { import_question } = this.parent;
            if (import_question && !value) {
                return false;
            }
            if (!value || !(value instanceof File)) return true;
            const fileName = value.name;
            // eslint-disable-next-line no-useless-escape
            const invalidCharacters = /[\/,*,?]/;
            return !invalidCharacters.test(fileName);
        })

        .test(
            'fileType',
            schemaTextValidateLogin.format.fileType,
            function (value) {
                const { import_question } = this.parent;
                if (!import_question) return true;
                if (!value) return true;

                return (
                    value instanceof File &&
                    [
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    ].includes(value.type)
                );
            }
        )
        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                const { import_question } = this.parent;
                if (!import_question) return true;
                if (!value) return true;

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
    email_template: yup
        .mixed()
        .nullable()
        .test(
            'is-required',
            schemaTextValidateLogin.format.fileRequired,
            function (value) {
                const { secure_type } = this.parent;
                // Nếu value có isExisting property (file đã tồn tại) thì pass
                if (
                    value &&
                    typeof value === 'object' &&
                    'isExisting' in value
                ) {
                    return true;
                }
                if (secure_type === 'unique_link' && !value) {
                    return false;
                }
                return true;
            }
        )
        .test('fileName', 'Tên file không hợp lệ', function (value) {
            const { secure_type } = this.parent;
            // Nếu value có isExisting property thì skip validation
            if (value && typeof value === 'object' && 'isExisting' in value) {
                return true;
            }
            if (secure_type === 'unique_link' && !value) {
                return false;
            }
            if (!value || !(value instanceof File)) return true;
            const fileName = value.name;
            // eslint-disable-next-line no-useless-escape
            const invalidCharacters = /[\/,*,?]/;
            return !invalidCharacters.test(fileName);
        })

        .test(
            'fileType',
            schemaTextValidateLogin.format.fileType,
            function (value) {
                const { secure_type } = this.parent;
                if (secure_type !== 'unique_link') return true;
                if (!value) return true;
                // Nếu value có isExisting property thì skip validation
                if (
                    value &&
                    typeof value === 'object' &&
                    'isExisting' in value
                ) {
                    return true;
                }

                return (
                    value instanceof File && ['text/html'].includes(value.type)
                );
            }
        )
        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                const { secure_type } = this.parent;
                if (secure_type !== 'unique_link') return true;
                if (!value) return true;
                // Nếu value có isExisting property thì skip validation
                if (
                    value &&
                    typeof value === 'object' &&
                    'isExisting' in value
                ) {
                    return true;
                }

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
    logo: yup
        .mixed()
        .nullable()
        .test(
            'is-required',
            schemaTextValidateLogin.format.fileRequired,
            function (value) {
                const { secure_type } = this.parent;
                // Nếu value có isExisting property (file đã tồn tại) thì pass
                if (
                    value &&
                    typeof value === 'object' &&
                    'isExisting' in value
                ) {
                    return true;
                }
                if (secure_type === 'unique_link' && !value) {
                    return false;
                }
                return true;
            }
        )
        .test('fileName', 'Tên file không hợp lệ', function (value) {
            const { secure_type } = this.parent;
            // Nếu value có isExisting property thì skip validation
            if (value && typeof value === 'object' && 'isExisting' in value) {
                return true;
            }
            if (secure_type === 'unique_link' && !value) {
                return false;
            }
            if (!value || !(value instanceof File)) return true;
            const fileName = value.name;
            // eslint-disable-next-line no-useless-escape
            const invalidCharacters = /[\/,*,?]/;
            return !invalidCharacters.test(fileName);
        })

        .test(
            'fileType',
            schemaTextValidateLogin.format.fileType,
            function (value) {
                const { secure_type } = this.parent;
                if (secure_type !== 'unique_link') return true;
                if (!value) return true;
                // Nếu value có isExisting property thì skip validation
                if (
                    value &&
                    typeof value === 'object' &&
                    'isExisting' in value
                ) {
                    return true;
                }

                return (
                    value instanceof File && ['image/png'].includes(value.type)
                );
            }
        )
        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                const { secure_type } = this.parent;
                if (secure_type !== 'unique_link') return true;
                if (!value) return true;
                // Nếu value có isExisting property thì skip validation
                if (
                    value &&
                    typeof value === 'object' &&
                    'isExisting' in value
                ) {
                    return true;
                }

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
});

export const profileSchema = yup.object().shape({
    uid: yup.string(),
    avatar: yup
        .mixed()
        .nullable()
        .notRequired()
        .test(
            'fileType',
            'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }
                const isValidType =
                    value instanceof File &&
                    SUPPORTED_FORMATS.includes(value.type);

                return isValidType;
            }
        )

        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
    username: yup.string().trim().required(schemaTextValidate.required.default),
    email: yup.string().matches(regexEmail, schemaTextValidate.format.email),
});

export const profileChangePasswordSchema = yup.object().shape({
    current_password: yup
        .string()
        .required(schemaTextValidate.required.default),
    password: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexPassword, schemaTextValidate.format.password)
        .test(
            'not-same-as-current',
            schemaTextValidate.format.sameAsCurrentPassword,
            function (value) {
                const { current_password } = this.parent;
                return value !== current_password;
            }
        ),
    password_confirmation: yup
        .string()
        .required(schemaTextValidate.required.default)
        .oneOf(
            [yup.ref('password')],
            schemaTextValidate.format.confirmPassword
        ),
});

export const checkboxQuestionSchema = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup.number(),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
    minimumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
    maximumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
});

export const checkboxQuestionPageLogicSchemaRequired = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            question_page_id: yup
                .number()
                .required(schemaTextValidate.required.default),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup.number(),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
    minimumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
    maximumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
});

export const checkboxQuestionPageLogicSchema = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            question_page_id: yup.number().nullable(),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup.number(),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
    minimumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
    maximumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
});

export const singleChoiceQuestionSchemaZeroNumberOfRows = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfRows),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
});

export const checkboxQuestionSchemaZeroNumberOfRows = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfRows),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
    minimumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
    maximumAnswerChoice: yup
        .number()
        .required(schemaTextValidate.required.default),
});

export const singleChoiceQuestionSchema = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
});

export const singleChoiceQuestionPageLogicSchema = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            question_page_id: yup.number().nullable(),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
});

export const singleChoiceQuestionPageLogicSchemaRequired = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            question_page_id: yup
                .number()
                .required(schemaTextValidate.required.default),
            image: yup
                .mixed()
                .nullable()
                .test(
                    'fileType',
                    'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }
                        const isValidType =
                            value instanceof File &&
                            SUPPORTED_FORMATS.includes(value.type);

                        return isValidType;
                    }
                )

                .test(
                    'fileSize',
                    schemaTextValidateLogin.format.fileSize,
                    function (value) {
                        if (!value) {
                            return true;
                        }
                        if (
                            typeof value === 'string' &&
                            value.startsWith('http')
                        ) {
                            return true;
                        }

                        return (
                            value instanceof File &&
                            value.size <= FILE_SIZE_LIMIT
                        );
                    }
                ),
        })
    ),
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    addAnotherAnswer: yup.boolean(),
    anotherAnswerText: yup.string().nullable(),
    insertImage: yup.boolean(),
    addNoAnswersYet: yup.boolean(),
    insertMultipleAnswers: yup.boolean(),
    sortAnswers: yup.string(),
});

export const scoreStarQuestionSchema = yup.object().shape({
    // quantity: yup.number(),
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            score: yup.number(),
        })
    ),
});
export const textboxQuestionSchema = yup.object().shape({});

export const scoreQuestionSchema = yup.object().shape({
    // numberOfRows: yup.number(),
    gap: yup.number().required(schemaTextValidate.required.default),
    scale: yup.number().required(schemaTextValidate.required.default),
    // answers: yup.array().of(
    //     yup.object({
    //         answer: yup.string().required(schemaTextValidate.required.default),
    //     })
    // ),
});
export const dropdownQuestionSchema = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    sortAnswers: yup.string(),
});
export const dropdownQuestionSchemaZeroNumberOfRows = yup.object().shape({
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    numberOfRows: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfRows),
    sortAnswers: yup.string(),
});
export const imageQuestionSchema = yup.object().shape({
    limitSize: yup.number(),
    // .required('Vui lòng nhập giới hạn dung lượng')
    // .min(1, 'Giới hạn dung lượng phải lớn hơn 0')
    // .max(20, 'Giới hạn dung lượng không được lớn hơn 20'),
});
export const imageWithTitleQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    limitSize: yup.number(),
    // .required('Vui lòng nhập giới hạn dung lượng')
    // .min(1, 'Giới hạn dung lượng phải lớn hơn 0')
    // .max(20, 'Giới hạn dung lượng không được lớn hơn 20'),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
        })
    ),
});

export const textboxRecommendQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    // limitCharacter: yup
    //     .number()
    //     .required('Vui lòng nhập giới hạn ký tự nhập')
    //     .min(
    //         3,
    //         'Vui lòng nhập giới hạn ký tự nhập tối thiểu 3 ký tự và tối đa 1000 ký tự'
    //     )
    //     .max(
    //         1000,
    //         'Vui lòng nhập giới hạn ký tự nhập tối thiểu 3 ký tự và tối đa 1000 ký tự'
    //     ),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
        })
    ),
});
export const textboxRecommendQuestionSchemaZeroNumberOfRows = yup
    .object()
    .shape({
        numberOfRows: yup
            .number()
            .min(0, schemaTextValidate.campaignOverview.numberOfRows),
        // limitCharacter: yup
        //     .number()
        //     .required('Vui lòng nhập giới hạn ký tự nhập')
        //     .min(
        //         3,
        //         'Vui lòng nhập giới hạn ký tự nhập tối thiểu 3 ký tự và tối đa 1000 ký tự'
        //     )
        //     .max(
        //         1000,
        //         'Vui lòng nhập giới hạn ký tự nhập tối thiểu 3 ký tự và tối đa 1000 ký tự'
        //     ),
        answers: yup.array().of(
            yup.object({
                answer: yup
                    .string()
                    .required(schemaTextValidate.required.default),
            })
        ),
    });
export const emojiQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    numberOfEmoji: yup.number(),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
        })
    ),
});

export const textBoxRecommendMultiChoiceQuestionSchema = yup.object().shape({
    // minimumAnswerChoice: yup.number(),
    // maximumAnswerChoice: yup.number(),
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
        })
    ),
});
export const textBoxRecommendMultiChoiceQuestionSchemaZeroNumberOfRows = yup
    .object()
    .shape({
        // minimumAnswerChoice: yup.number(),
        // maximumAnswerChoice: yup.number(),
        numberOfRows: yup
            .number()
            .min(0, schemaTextValidate.campaignOverview.numberOfRows),
        answers: yup.array().of(
            yup.object({
                answer: yup
                    .string()
                    .required(schemaTextValidate.required.default),
            })
        ),
    });
export const rankQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    sortAnswers: yup.string(),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            rank: yup.number(),
        })
    ),
});
export const sliderScaleQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án cho câu hỏi');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    gap: yup.mixed(),
    scale: yup.mixed(),
    answers: yup.array().of(
        yup.object({
            answer: yup.string().required(schemaTextValidate.required.default),
            score: yup.number(),
        })
    ),
});

export const matrixTextboxQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án theo hàng');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    numberOfColumns: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfColumns,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án theo cột');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    answers: yup.array().of(
        yup.object({
            answer: yup.string(),
        })
    ),
    rows: yup.array().of(
        yup.object({
            label: yup.string(),
        })
    ),
    columns: yup.array().of(
        yup.object({
            label: yup.string(),
        })
    ),
});

export const matrixTextboxQuestionSchemaZeroNumberOfRows = yup.object().shape({
    numberOfRows: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfRows),
    numberOfColumns: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfColumns),
    answers: yup.array().of(
        yup.object({
            answer: yup.string(),
        })
    ),
    rows: yup.array().of(
        yup.object({
            label: yup.string(),
        })
    ),
    columns: yup.array().of(
        yup.object({
            label: yup.string(),
        })
    ),
});

export const matrixCheckboxQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án theo hàng');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    numberOfColumns: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfColumns,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án theo cột');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    answers: yup.array().of(
        yup.object({
            answer: yup.string(),
        })
    ),
    rows: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    columns: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    minimumAnswerChoice: yup.number().nullable(),
    // .required(schemaTextValidate.required.default),
    maximumAnswerChoice: yup.number().nullable(),
    // .required(schemaTextValidate.required.default),
    sortAnswers: yup.string(),
    direction: yup.string(),
});

export const matrixCheckboxQuestionSchemaZeroNumberOfRows = yup.object().shape({
    numberOfRows: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfRows),
    numberOfColumns: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfColumns),
    answers: yup.array().of(
        yup.object({
            answer: yup.string(),
        })
    ),
    rows: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    columns: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    minimumAnswerChoice: yup.number().nullable(),
    // .required(schemaTextValidate.required.default),
    maximumAnswerChoice: yup.number().nullable(),
    // .required(schemaTextValidate.required.default),
    sortAnswers: yup.string(),
    direction: yup.string(),
});

export const matrixRadioQuestionSchema = yup.object().shape({
    numberOfRows: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfRows,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án theo hàng');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    numberOfColumns: yup.number(),
    // .test(
    //     'is-required',
    //     schemaTextValidate.campaignOverview.numberOfColumns,
    //     function (value) {
    //         if (!value || value < 1) {
    //             toast.error('Vui lòng nhập đáp án theo cột');
    //             return false;
    //         }
    //         return true;
    //     }
    // ),
    answers: yup.array().of(
        yup.object({
            answer: yup.string(),
        })
    ),
    rows: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    columns: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    sortAnswers: yup.string(),
    direction: yup.string(),
});

export const matrixRadioQuestionSchemaZeroNumberOfRows = yup.object().shape({
    numberOfRows: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfRows),
    numberOfColumns: yup
        .number()
        .min(0, schemaTextValidate.campaignOverview.numberOfColumns),
    answers: yup.array().of(
        yup.object({
            answer: yup.string(),
        })
    ),
    rows: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    columns: yup.array().of(
        yup.object({
            label: yup.string().required(schemaTextValidate.required.default),
        })
    ),
    sortAnswers: yup.string(),
    direction: yup.string(),
});

export const campaignDesignQuestionSchema = yup.object().shape({
    id: yup.mixed().nullable(),
    question: yup
        .string()
        .trim()
        .required(schemaTextValidate.required.question),
    questionType: yup.string().required(schemaTextValidate.required.choice),
    required: yup.boolean().nullable(),
    questionNumber: yup.number().nullable(),
    questionIdForTitle: yup.number().nullable(),
    mentionStartPos: yup.number().nullable(),
    mentionEndPos: yup.number().nullable(),
    mentionValue: yup.string().nullable(),
    data: yup.lazy((value, { parent }) => {
        // switch schema by questionType
        // mỗi loại câu hỏi sẽ là 1 schema riêng
        if (value === null) {
            return yup.mixed().nullable();
        }
        switch (parent.questionType) {
            case QuestionType.Checkbox: {
                if (parent.takeAnswerFromOtherQuestion) {
                    return checkboxQuestionSchemaZeroNumberOfRows;
                }
                return checkboxQuestionSchema;
            }
            case QuestionType.SingleChoice:
                if (parent.takeAnswerFromOtherQuestion) {
                    return singleChoiceQuestionSchemaZeroNumberOfRows;
                }
                return singleChoiceQuestionSchema;
            case QuestionType.Textbox:
                return textboxQuestionSchema;
            case QuestionType.ScoreStarHalf:
            case QuestionType.ScoreStarFull:
                return scoreStarQuestionSchema;
            case QuestionType.Score:
                return scoreQuestionSchema;
            case QuestionType.Dropdown:
                if (parent.takeAnswerFromOtherQuestion) {
                    return dropdownQuestionSchemaZeroNumberOfRows;
                }
                return dropdownQuestionSchema;
            case QuestionType.Image:
                return imageQuestionSchema;
            case QuestionType.ImageWithTitle:
                return imageWithTitleQuestionSchema;
            case QuestionType.TextboxRecommend:
                if (parent.takeAnswerFromOtherQuestion) {
                    return textboxRecommendQuestionSchemaZeroNumberOfRows;
                }
                return textboxRecommendQuestionSchema;
            case QuestionType.Emoji:
                return emojiQuestionSchema;
            case QuestionType.TextboxRecommendMultiChoice:
                if (parent.takeAnswerFromOtherQuestion) {
                    return textBoxRecommendMultiChoiceQuestionSchemaZeroNumberOfRows;
                }
                return textBoxRecommendMultiChoiceQuestionSchema;
            case QuestionType.Rank:
                return rankQuestionSchema;
            case QuestionType.SliderScale:
                return sliderScaleQuestionSchema;
            case QuestionType.MatrixText:
                if (parent.takeAnswerFromOtherQuestion) {
                    return matrixTextboxQuestionSchemaZeroNumberOfRows;
                }
                return matrixTextboxQuestionSchema;
            case QuestionType.MatrixCheckbox:
                if (parent.takeAnswerFromOtherQuestion) {
                    return matrixCheckboxQuestionSchemaZeroNumberOfRows;
                }
                return matrixCheckboxQuestionSchema;
            case QuestionType.MatrixRadio:
                if (parent.takeAnswerFromOtherQuestion) {
                    return matrixRadioQuestionSchemaZeroNumberOfRows;
                }
                return matrixRadioQuestionSchema;
            default:
                return yup.mixed().notRequired();
        }
    }),
});

export const campaignDesignQuestionLogicPageSchema = yup.object().shape({
    id: yup.mixed().nullable(),
    question: yup
        .string()
        .trim()
        .required(schemaTextValidate.required.question),
    questionType: yup.string().required(schemaTextValidate.required.choice),
    isPageConfig: yup.boolean().nullable(),
    required: yup.boolean().nullable(),
    questionNumber: yup.number().nullable(),
    questionIdForTitle: yup.number().nullable(),
    mentionStartPos: yup.number().nullable(),
    mentionEndPos: yup.number().nullable(),
    mentionValue: yup.string().nullable(),
    data: yup.lazy((value, { parent }) => {
        // switch schema by questionType
        // mỗi loại câu hỏi sẽ là 1 schema riêng
        if (value === null) {
            return yup.mixed().nullable();
        }
        const isPageConfig = parent.isPageConfig;
        switch (parent.questionType) {
            case QuestionType.Checkbox: {
                if (parent.takeAnswerFromOtherQuestion) {
                    return checkboxQuestionSchemaZeroNumberOfRows;
                }
                if (isPageConfig) {
                    return checkboxQuestionPageLogicSchemaRequired;
                }
                return checkboxQuestionPageLogicSchema;
            }
            case QuestionType.SingleChoice:
                if (parent.takeAnswerFromOtherQuestion) {
                    return singleChoiceQuestionSchemaZeroNumberOfRows;
                }
                if (isPageConfig) {
                    return singleChoiceQuestionPageLogicSchemaRequired;
                }
                return singleChoiceQuestionPageLogicSchema;
            case QuestionType.Textbox:
                return textboxQuestionSchema;
            case QuestionType.ScoreStarHalf:
            case QuestionType.ScoreStarFull:
                return scoreStarQuestionSchema;
            case QuestionType.Score:
                return scoreQuestionSchema;
            case QuestionType.Dropdown:
                if (parent.takeAnswerFromOtherQuestion) {
                    return dropdownQuestionSchemaZeroNumberOfRows;
                }
                return dropdownQuestionSchema;
            case QuestionType.Image:
                return imageQuestionSchema;
            case QuestionType.ImageWithTitle:
                return imageWithTitleQuestionSchema;
            case QuestionType.TextboxRecommend:
                if (parent.takeAnswerFromOtherQuestion) {
                    return textboxRecommendQuestionSchemaZeroNumberOfRows;
                }
                return textboxRecommendQuestionSchema;
            case QuestionType.Emoji:
                return emojiQuestionSchema;
            case QuestionType.TextboxRecommendMultiChoice:
                if (parent.takeAnswerFromOtherQuestion) {
                    return textBoxRecommendMultiChoiceQuestionSchemaZeroNumberOfRows;
                }
                return textBoxRecommendMultiChoiceQuestionSchema;
            case QuestionType.Rank:
                return rankQuestionSchema;
            case QuestionType.SliderScale:
                return sliderScaleQuestionSchema;
            case QuestionType.MatrixText:
                if (parent.takeAnswerFromOtherQuestion) {
                    return matrixTextboxQuestionSchemaZeroNumberOfRows;
                }
                return matrixTextboxQuestionSchema;
            case QuestionType.MatrixCheckbox:
                if (parent.takeAnswerFromOtherQuestion) {
                    return matrixCheckboxQuestionSchemaZeroNumberOfRows;
                }
                return matrixCheckboxQuestionSchema;
            case QuestionType.MatrixRadio:
                if (parent.takeAnswerFromOtherQuestion) {
                    return matrixRadioQuestionSchemaZeroNumberOfRows;
                }
                return matrixRadioQuestionSchema;
            default:
                return yup.mixed().notRequired();
        }
    }),
});

export const skipQuestionSchema = yup.object().shape({
    logics: yup
        .array()
        .of(
            yup.object({
                question: yup
                    .number()
                    .required(schemaTextValidate.required.choice),
                condition: yup
                    .number()
                    .required(schemaTextValidate.required.choice),
                answer: yup
                    .mixed()
                    .required(schemaTextValidate.required.choice),
            })
        )
        .test('is-unique', 'Điều kiện trùng lặp', function (logics) {
            const seenSame = new Set();
            const seenSameCondition = new Set();
            let duplicatesErrorMessage = '';
            const duplicates = logics?.some((logic) => {
                const identifierSame = `${logic.question}-${logic.condition}-${logic.answer}`;
                const identifierSameCondition = `${logic.question}-${logic.answer}`;

                if (seenSame.has(identifierSame)) {
                    duplicatesErrorMessage = 'Điều kiện trùng lặp';
                    return true;
                }
                seenSame.add(identifierSame);
                if (seenSameCondition.has(identifierSameCondition)) {
                    duplicatesErrorMessage =
                        'Điều kiện chọn và không chọn cho cùng 1 đáp án';
                    return true;
                }
                seenSameCondition.add(identifierSameCondition);
                return '';
            });

            if (duplicates) {
                return this.createError({
                    message: duplicatesErrorMessage,
                });
            }
            return true;
        }),
});

export const creeningLogicSchema = yup.object().shape({
    logics: yup
        .array()
        .of(
            yup.object({
                question: yup
                    .number()
                    .required(schemaTextValidate.required.choice),
                condition: yup
                    .number()
                    .required(schemaTextValidate.required.choice),
                answer: yup
                    .mixed()
                    .required(schemaTextValidate.required.choice),
            })
        )
        .test('is-unique', 'Điều kiện trùng lặp', function (logics) {
            const seenSame = new Set();
            const seenSameCondition = new Set();
            let duplicatesErrorMessage = '';
            const duplicates = logics?.some((logic) => {
                const identifierSame = `${logic.question}-${logic.condition}-${logic.answer}`;
                const identifierSameCondition = `${logic.question}-${logic.answer}`;

                if (seenSame.has(identifierSame)) {
                    duplicatesErrorMessage = 'Điều kiện trùng lặp';
                    return true;
                }
                seenSame.add(identifierSame);
                if (seenSameCondition.has(identifierSameCondition)) {
                    duplicatesErrorMessage =
                        'Điều kiện chọn và không chọn cho cùng 1 đáp án';
                    return true;
                }
                seenSameCondition.add(identifierSameCondition);
                return false;
            });

            if (duplicates) {
                return this.createError({
                    message: duplicatesErrorMessage,
                });
            }
            return true;
        }),
});

export const branchQuestionSchema = yup.object().shape({
    logics: yup
        .array()
        .of(
            yup.object({
                question: yup
                    .number()
                    .required(schemaTextValidate.required.choice),
                conditions: yup.array().of(
                    yup.object({
                        condition: yup
                            .number()
                            .required(schemaTextValidate.required.choice),
                        answer: yup
                            .number()
                            .required(schemaTextValidate.required.choice),
                    })
                ),
                jumpToQuestion: yup
                    .number()
                    .required(schemaTextValidate.required.choice),
            })
        )
        .test('is-unique', 'Điều kiện trùng lặp', function (logics) {
            const seen = new Set();
            const seen1 = new Set();
            let duplicatesErrorMessage = '';
            const duplicates = logics?.some((logic) => {
                if (!logic.conditions) return false;
                return logic.conditions.some((condition) => {
                    const identifier = `${condition.condition}-${condition.answer}-${logic.jumpToQuestion}`;
                    const identifier1 = `${condition.answer}-${logic.jumpToQuestion}`;
                    if (seen.has(identifier)) {
                        duplicatesErrorMessage = 'Điều kiện trùng lặp';
                        return true;
                    }
                    seen.add(identifier);
                    if (seen1.has(identifier1)) {
                        duplicatesErrorMessage =
                            'Điều kiện chọn và không chọn cho cùng 1 đáp án';
                        return true;
                    }
                    seen1.add(identifier1);
                    return false;
                });
            });

            if (duplicates) {
                return this.createError({
                    message: duplicatesErrorMessage,
                });
            }
            return true;
        }),
});

export const onDisplaySelectedChoiceSchema = yup.object().shape({
    answerQuestion: yup.number().required(),
    takenFromTheQuestionAnswer: yup.number().nullable(),
    takenFromTheQuestionAnswerForRow: yup.number().nullable(),
    takenFromTheQuestionAnswerForColumn: yup.number().nullable(),
});

export const logicDisplayOnTitleSchema = yup.object().shape({
    question: yup.string().required(schemaTextValidate.required.default),
});

export const uploadFileQuestionSchema = yup.object().shape({
    file: yup
        .mixed()
        .nullable()
        .test('fileName', 'Tên file không hợp lệ', function (value) {
            if (!value || !(value instanceof File)) return true;
            const fileName = value.name;
            // eslint-disable-next-line no-useless-escape
            const invalidCharacters = /[\/,*,?]/;
            return !invalidCharacters.test(fileName);
        })
        .test(
            'fileType',
            schemaTextValidateLogin.format.fileType,
            function (value) {
                if (!value) return true;
                const isValidType =
                    value instanceof File &&
                    value.type ===
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                return isValidType;
            }
        )

        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                if (!value) return true;

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
});

export const surveyFreeSchema = yup.object().shape({
    url: yup.string(),
    code: yup.string(),
    quantity: yup
        .number()
        .required('Số lượng không được để trống')
        .max(10000, 'Vui lòng nhập số lượng tối đa 10 000')
        .min(1, 'Vui lòng nhập số lượng tối thiểu 1'),
});

export const servicePaymentSchema = yup.object().shape({
    numberOfPeople: yup
        .number()
        .required('Số lượng không được để trống')
        .max(1000000, 'Vui lòng nhập số lượng tối đa 1 000 000')
        .min(10, 'Vui lòng nhập số lượng tối thiểu 10'),
    isRegionIncluded: yup.boolean(),
    isAgeIncluded: yup.boolean(),
    isChildrenIncluded: yup.boolean(),
    isFieldIncluded: yup.boolean(),
    isMaritalStatusIncluded: yup.boolean(),
    isJobIncluded: yup.boolean(),
    isPersonalIncomeIncluded: yup.boolean(),
    isGenderIncluded: yup.boolean(),
    isFamilyIncomeIncluded: yup.boolean(),
    dob: yup.array(),
    gender: yup.array(),
    address: yup.array(),
    marriage: yup.array(),
    child: yup.array(),
    career: yup.array(),
    career_field: yup.array(),
    monthly_personal_income: yup.array(),
    monthly_family_income: yup.array(),
});

export const eInvoiceSchema = yup.object().shape({
    companyName: yup.string().nullable(),
    taxCode: yup.string().nullable(),
    address: yup.string().nullable(),
    invoiceRecipient: yup.string().nullable(),
    phone: yup.string().nullable(),
    email: yup.string().nullable().matches(regexEmail, {
        message: 'Email không hợp lệ',
        excludeEmptyString: true,
    }),
});

const allowedOperatorQuestionTypes = [
    'number',
    'slider_scale',
    'score_star_full',
    'score_star_half',
    'score',
    'emoji',
];
export const campaignDataAnalysisFilterSchema = yup.object().shape({
    questions: yup.array().of(
        yup.object({
            questionType: yup.string(),
            questionId: yup
                .string()
                .required('Vui lòng chọn')
                .test(
                    'unique-questionId',
                    'Câu hỏi này đã được chọn, vui lòng chọn câu hỏi khác',
                    function (value, context) {
                        if (!value) return true;
                        const allQuestions =
                            context?.from?.[1]?.value?.questions || [];
                        const duplicateCount = allQuestions.filter(
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            (question: any) =>
                                question.questionId === Number(value)
                        ).length;

                        return duplicateCount <= 1;
                    }
                ),

            availableAnswers: yup.array().of(
                yup.object({
                    label: yup.string(),
                    value: yup.string(),
                })
            ),
            operator: yup.string().when('questionType', {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                is: (questionType: any) =>
                    [
                        'number',
                        'slider_scale',
                        'score_star_full',
                        'score_star_half',
                        'score',
                        'date',
                        'emoji',
                    ].includes(questionType),
                then: (schema) => schema.required('Vui lòng chọn'),
                otherwise: (schema) => schema.notRequired(),
            }),
            date: yup.date().when('questionType', {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                is: (questionType: any) => questionType === 'date',
                then: (schema) => schema.required('Vui lòng chọn ngày'),
                otherwise: (schema) => schema.notRequired(),
            }),
            number: yup.string().when('questionType', {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                is: (questionType: any) =>
                    allowedOperatorQuestionTypes.includes(questionType),
                then: (schema) =>
                    schema
                        .required('Vui lòng nhập')
                        .matches(
                            /^\d+(\.\d+)?$/,
                            'Vui lòng nhập một số hợp lệ'
                        ),
                otherwise: (schema) => schema.notRequired(),
            }),
            // .test('validate-number-range', (value, context) => {
            //     const numValue = parseFloat(value ?? '');
            //     const questionType = context.parent.questionType;
            //     const rangeMap: Record<string, [number, number]> = {
            //         slider_scale: [0, 100],
            //         score: [0, 100],
            //         score_star_half: [0, 5],
            //         score_star_full: [0, 5],
            //     };
            //     if (questionType in rangeMap) {
            //         const [min, max] = rangeMap[questionType];
            //         if (numValue < min || numValue > max) {
            //             return context.createError({
            //                 message: `Số phải từ ${min} đến ${max}`,
            //             });
            //         }
            //     }

            //     return true;
            // }),
            answersRank: yup.array().of(
                yup.object({
                    value: yup
                        .string()
                        .test(
                            'required-if-rank',
                            'Vui lòng chọn',
                            function (value, context) {
                                console.log(
                                    context?.from?.[1]?.value?.questionType
                                );
                                const questionType =
                                    context?.from?.[1]?.value?.questionType;

                                if (
                                    questionType === 'rank' &&
                                    (!value || value.trim() === '')
                                ) {
                                    return false;
                                }

                                return true;
                            }
                        ),
                })
            ),
            answers: yup
                .array()
                .test(
                    'validate-answers',
                    'Vui lòng chọn ít nhất 1 đáp án',
                    function (value, context) {
                        const questionType =
                            context?.from?.[0]?.value?.questionType;
                        const requiredTypes = [
                            'checkbox',
                            'single_choice',
                            'dropdown',
                            'textbox_recommend',
                            'textbox_recommend_multi_choice',
                        ];

                        if (requiredTypes.includes(questionType)) {
                            return Array.isArray(value) && value.length > 0;
                        }

                        return true;
                    }
                ),
        })
    ),
});
export const campaignDataAnalysisCompareSchema = yup.object().shape({
    questions: yup.array().of(
        yup.object({
            questionType: yup.string(),
            questionId: yup
                .string()
                .required('Vui lòng chọn')
                .test(
                    'unique-questionId',
                    'Câu hỏi này đã được chọn, vui lòng chọn câu hỏi khác',
                    function (value, context) {
                        if (!value) return true;
                        const allQuestions =
                            context?.from?.[1]?.value?.questions || [];
                        const duplicateCount = allQuestions.filter(
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            (question: any) =>
                                question.questionId === Number(value)
                        ).length;

                        return duplicateCount <= 1;
                    }
                ),

            availableAnswers: yup.array().of(
                yup.object({
                    label: yup.string(),
                    value: yup.string(),
                })
            ),

            answers: yup
                .array()
                .test(
                    'validate-answers',
                    'Vui lòng chọn ít nhất 1 đáp án',
                    function (value, context) {
                        const questionType =
                            context?.from?.[0]?.value?.questionType;
                        const requiredTypes = [
                            'checkbox',
                            'single_choice',
                            'dropdown',
                            'textbox_recommend',
                            'textbox_recommend_multi_choice',
                        ];

                        if (requiredTypes.includes(questionType)) {
                            return Array.isArray(value) && value.length > 0;
                        }

                        return true;
                    }
                ),
        })
    ),
});

export const paymentSelectObjectSchema = yup.object().shape({
    package: yup.string().required('Vui lòng nhập'),
    upgradeService: yup.string(),
    month: yup.string(),
    price: yup.string(),
    customerName: yup
        .object({
            label: yup.string(),
            value: yup.number().nullable(),
        })
        .nullable()
        .test(
            'campaign-required',
            'Vui lòng nhập',
            (value) => !!(value?.label || value?.value)
        ),
    additionalFields: yup.lazy((_, context) => {
        if (context?.parent?.package === 'Survey') {
            return yup.object().shape({
                age: yup.array(),
                gender: yup.array(),
                region: yup.array(),
                maritalStatus: yup.array(),
                children: yup.array(),
                job: yup.array(),
                field: yup.array(),
                personalIncome: yup.array(),
                familyIncome: yup.array(),
                campaign: yup
                    .object({
                        label: yup.string(),
                        value: yup.string(),
                    })
                    .nullable()
                    .test(
                        'campaign-required',
                        'Vui lòng nhập',
                        (value) => !!(value?.label || value?.value)
                    ),

                numberOfPeople: yup
                    .number()
                    .required('Số lượng không được để trống')
                    .max(1000000, 'Vui lòng nhập số lượng tối đa 1 000 000')
                    .min(10, 'Vui lòng nhập số lượng tối thiểu 10'),
                isRegionIncluded: yup.boolean(),
                isAgeIncluded: yup.boolean(),
                isChildrenIncluded: yup.boolean(),
                isFieldIncluded: yup.boolean(),
                isMaritalStatusIncluded: yup.boolean(),
                isJobIncluded: yup.boolean(),
                isPersonalIncomeIncluded: yup.boolean(),
                isGenderIncluded: yup.boolean(),
                isFamilyIncomeIncluded: yup.boolean(),
            });
        }
        return yup.mixed();
    }),
});

export const accountFilterSchema = yup.object().shape({
    searchKeyWord: yup.string(),
    status: yup.array(),
    type: yup.array(),
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
});

export const overViewFilterSchema = yup.object().shape({
    searchKeyWord: yup.string(),
    status: yup.array(),
    region: yup.array(),
    device: yup.array(),
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
});

export const dataCollectFilterSchema = yup.object().shape({
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
    status: yup.array(),
    device: yup.array(),
});

export const accountSchema = yup.object().shape({
    uid: yup.string(),
    avatar: yup
        .mixed()
        .nullable()
        .notRequired()
        .test(
            'fileType',
            'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }
                const isValidType =
                    value instanceof File &&
                    SUPPORTED_FORMATS.includes(value.type);

                return isValidType;
            }
        )

        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
    username: yup.string().required(schemaTextValidate.required.default),
    email: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexEmail, schemaTextValidate.format.email),
    status: yup.boolean(),
    role: yup.string().required(schemaTextValidate.required.default),
});

export const customerFilterSchema = yup.object().shape({
    searchKeyWord: yup.string(),
    status: yup.array(),
    source: yup.array(),
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
});

export const campaignOverviewFilterSchema = yup.object().shape({
    searchKeyWord: yup.string(),
    area: yup.array(),
    device: yup.array(),
    service: yup.array(),
    startDate: yup.string().nullable(),
    endDate: yup.string().nullable(),
});

export const customerSchema = yup.object().shape({
    uid: yup.string(),
    avatar: yup
        .mixed()
        .nullable()
        .notRequired()
        .test(
            'fileType',
            'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }
                const isValidType =
                    value instanceof File &&
                    SUPPORTED_FORMATS.includes(value.type);

                return isValidType;
            }
        )

        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }

                return value instanceof File && value.size <= FILE_SIZE_LIMIT;
            }
        ),
    username: yup.string().required(schemaTextValidate.required.default),
    email: yup.string().matches(regexEmail, schemaTextValidate.format.email),
    status: yup.boolean(),
});

export const generalConfigurationsSchema = yup.object().shape({
    email: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexEmail, schemaTextValidate.format.email),
    hotline: yup.string().required(schemaTextValidate.required.default),
    password: yup
        .string()
        .required(schemaTextValidate.required.default)
        .matches(regexPassword, schemaTextValidate.format.password),
    qr: yup.string().required(schemaTextValidate.required.default),
    copyRight: yup
        .string()
        .required(schemaTextValidate.required.default)
        .max(255, schemaTextValidate.format.max(255)),
    terms: yup
        .string()
        .required(schemaTextValidate.required.default)
        .max(2000, schemaTextValidate.format.max(2000)),
    logo: yup
        .mixed()
        .nullable()
        .notRequired()
        .test(
            'fileType',
            'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }
                const isValidType =
                    value instanceof File &&
                    SUPPORTED_FORMATS.includes(value.type);

                return isValidType;
            }
        )
        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }

                return (
                    value instanceof File && value.size <= FILE_SIZE_LIMIT_20
                );
            }
        ),
    favicon: yup
        .mixed()
        .nullable()
        .notRequired()
        .test(
            'fileType',
            'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: jpg, .jpeg, .png',
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }
                const isValidType =
                    value instanceof File &&
                    SUPPORTED_FORMATS.includes(value.type);

                return isValidType;
            }
        )
        .test(
            'fileSize',
            schemaTextValidateLogin.format.fileSize,
            function (value) {
                if (!value) {
                    return true;
                }
                if (typeof value === 'string' && value.startsWith('http')) {
                    return true;
                }

                return (
                    value instanceof File && value.size <= FILE_SIZE_LIMIT_20
                );
            }
        ),
});

export const timeBasedIntervalsSchema = yup.object().shape({
    singleChoice_premier: yup.boolean(),
    singleChoice_advance: yup.boolean(),
    singleChoice_standard: yup.boolean(),
    singleChoice_basic: yup.boolean(),
    checkboxes_premier: yup.boolean(),
    checkboxes_advance: yup.boolean(),
    checkboxes_standard: yup.boolean(),
    checkboxes_basic: yup.boolean(),
    textbox_premier: yup.boolean(),
    textbox_advance: yup.boolean(),
    textbox_standard: yup.boolean(),
    textbox_basic: yup.boolean(),
    score_premier: yup.boolean(),
    score_advance: yup.boolean(),
    score_standard: yup.boolean(),
    score_basic: yup.boolean(),
    rank_premier: yup.boolean(),
    rank_advance: yup.boolean(),
    rank_standard: yup.boolean(),
    rank_basic: yup.boolean(),
    dropdown_premier: yup.boolean(),
    dropdown_advance: yup.boolean(),
    dropdown_standard: yup.boolean(),
    dropdown_basic: yup.boolean(),
    date_premier: yup.boolean(),
    date_advance: yup.boolean(),
    date_standard: yup.boolean(),
    date_basic: yup.boolean(),
    number_premier: yup.boolean(),
    number_advance: yup.boolean(),
    number_standard: yup.boolean(),
    number_basic: yup.boolean(),
    textboxRecommend_premier: yup.boolean(),
    textboxRecommend_advance: yup.boolean(),
    textboxRecommendMultiChoice_premier: yup.boolean(),
    textboxRecommendMultiChoice_advance: yup.boolean(),
    sliderScale_premier: yup.boolean(),
    sliderScale_advance: yup.boolean(),
    emoji_premier: yup.boolean(),
    emoji_advance: yup.boolean(),
    matrixRadio_premier: yup.boolean(),
    matrixRadio_advance: yup.boolean(),
    matrixCheckbox_premier: yup.boolean(),
    matrixCheckbox_advance: yup.boolean(),
    starRatingFull_premier: yup.boolean(),
    starRatingFull_advance: yup.boolean(),
    starRatingHalf_premier: yup.boolean(),
    starRatingHalf_advance: yup.boolean(),
    matrixText_premier: yup.boolean(),
    matrixText_advance: yup.boolean(),
    imageUpload_premier: yup.boolean(),
    imageUpload_advance: yup.boolean(),
    imageUploadWithTitle_premier: yup.boolean(),
    imageUploadWithTitle_advance: yup.boolean(),
    skipQuestion_premier: yup.boolean(),
    skipQuestion_advance: yup.boolean(),
    limitAnswer_premier: yup.boolean(),
    limitAnswer_advance: yup.boolean(),
    screeningLogic_premier: yup.boolean(),
    screeningLogic_advance: yup.boolean(),
    randomizeAnswer_premier: yup.boolean(),
    randomizeAnswer_advance: yup.boolean(),
    branchLogic_premier: yup.boolean(),
    branchLogic_advance: yup.boolean(),
    onlyDisplayChoice_premier: yup.boolean(),
    onlyDisplayChoice_advance: yup.boolean(),
    displayAnswerTitle_premier: yup.boolean(),
    displayAnswerTitle_advance: yup.boolean(),
    liveSurveyUrl_premier: yup.boolean(),
    liveSurveyUrl_advance: yup.boolean(),
    liveSurveyUrl_standard: yup.boolean(),
    liveSurveyUrl_basic: yup.boolean(),
    setMaxResponseCount_premier: yup.boolean(),
    setMaxResponseCount_advance: yup.boolean(),
    setMaxResponseCount_standard: yup.boolean(),
    setMaxResponseCount_basic: yup.boolean(),
    setSurveyEndDate_premier: yup.boolean(),
    setSurveyEndDate_advance: yup.boolean(),
    setSurveyEndDate_standard: yup.boolean(),
    setSurveyEndDate_basic: yup.boolean(),
    passwordProtectedSurveys_premier: yup.boolean(),
    passwordProtectedSurveys_advance: yup.boolean(),
    passwordProtectedSurveys_standard: yup.boolean(),
    passwordProtectedSurveys_basic: yup.boolean(),
    customSurveyUrls_premier: yup.boolean(),
    customSurveyUrls_advance: yup.boolean(),
    customSurveyUrls_standard: yup.boolean(),
    customSurveyUrls_basic: yup.boolean(),
    targetRespondent_premier: yup.boolean(),
    targetRespondent_advance: yup.boolean(),
    smsSurveys_premier: yup.boolean(),
    smsSurveys_advance: yup.boolean(),
    responseQuality_premier: yup.boolean(),
    responseQuality_advance: yup.boolean(),
    getQualifiedSurveyRespondents_premier: yup.boolean(),
    realTimeResults_premier: yup.boolean(),
    realTimeResults_advance: yup.boolean(),
    realTimeResults_standard: yup.boolean(),
    realTimeResults_basic: yup.boolean(),
    realTimeDashboard_premier: yup.boolean(),
    realTimeDashboard_advance: yup.boolean(),
    realTimeDashboard_standard: yup.boolean(),
    realTimeDashboard_basic: yup.boolean(),
    participantStatistics_premier: yup.boolean(),
    participantStatistics_advance: yup.boolean(),
    participantStatistics_standard: yup.boolean(),
    participantStatistics_basic: yup.boolean(),
    downloadChartsAsPng_premier: yup.boolean(),
    downloadChartsAsPng_advance: yup.boolean(),
    downloadChartsAsPng_standard: yup.boolean(),
    downloadChartsAsPng_basic: yup.boolean(),
    generateCustomChartsReports_premier: yup.boolean(),
    generateCustomChartsReports_advance: yup.boolean(),
    generateCustomChartsReports_standard: yup.boolean(),
    generateCustomChartsReports_basic: yup.boolean(),
    rawDataExportXls_premier: yup.boolean(),
    rawDataExportXls_advance: yup.boolean(),
    rawDataExportXls_standard: yup.boolean(),
    rawDataExportXls_basic: yup.boolean(),
    filterResults_premier: yup.boolean(),
    filterResults_advance: yup.boolean(),
    filterResults_standard: yup.boolean(),
    compareResults_premier: yup.boolean(),
    compareResults_advance: yup.boolean(),
    downloadResultsInPptFormat_premier: yup.boolean(),
    downloadResultsInPptFormat_advance: yup.boolean(),
    clickMapDataVisualization_premier: yup.boolean(),
    exportToSpss_premier: yup.boolean(),
    respondentProfile_premier: yup.boolean(),
    email247Support_premier: yup.boolean(),
    email247Support_advance: yup.boolean(),
    email247Support_standard: yup.boolean(),
    email247Support_basic: yup.boolean(),
    expeditedEmailSupport_premier: yup.boolean(),
    expeditedEmailSupport_advance: yup.boolean(),
    expeditedEmailSupport_standard: yup.boolean(),
    phoneSupport_premier: yup.boolean(),
    phoneSupport_advance: yup.boolean(),
});

export const eInvoiceUpgradeServiceSchema = yup.object().shape({
    companyName: yup.string().nullable(),
    taxCode: yup
        .string()
        .nullable()
        .notRequired()
        .matches(/^\d*$/, 'Vui lòng nhập số')
        .max(13, 'Mã số thuế tối đa 13 chữ số'),

    address: yup.string().nullable(),
    invoiceRecipient: yup.string().nullable(),
    phone: yup
        .string()
        .nullable()
        .notRequired()
        .transform((value) => {
            if (typeof value !== 'string') return null;
            const trimmed = value.trim();
            return trimmed === '' ? null : trimmed;
        })
        .matches(phoneRegExp, 'Số điện thoại không hợp lệ'),

    email: yup.string().nullable().matches(regexEmail, {
        message: 'Email không hợp lệ',
        excludeEmptyString: true,
    }),
});

export const paymentNewSchema = yup.object().shape({
    fullName: yup.string().required('Vui lòng nhập'),
    phoneNumber: yup.string().required('Vui lòng nhập'),
    email: yup
        .string()
        .required('Vui lòng nhập')
        .matches(regexEmail, schemaTextValidate.format.email),
    exportInvoice: yup.boolean(),
    taxCode: yup.string().when('exportInvoice', {
        is: true,
        then: (schema) => schema.required('Vui lòng nhập'),
        otherwise: (schema) => schema.optional(),
    }),
    companyName: yup.string().when('exportInvoice', {
        is: true,
        then: (schema) => schema.required('Vui lòng nhập'),
        otherwise: (schema) => schema.optional(),
    }),
    address: yup.string().when('exportInvoice', {
        is: true,
        then: (schema) => schema.required('Vui lòng nhập'),
        otherwise: (schema) => schema.optional(),
    }),
    invoiceEmail: yup
        .string()
        .nullable()
        .when('exportInvoice', {
            is: true,
            then: (schema) =>
                schema
                    .required('Vui lòng nhập')
                    .matches(regexEmail, schemaTextValidate.format.email),
            otherwise: (schema) =>
                schema
                    .notRequired()
                    .test(
                        'is-valid-or-empty',
                        schemaTextValidate.format.email,
                        (value) => {
                            if (!value) return true;
                            return regexEmail.test(value);
                        }
                    ),
        }),

    paymentMethod: yup.string(),
    month: yup.string().required('Vui lòng chọn'),
    servicePackage: yup.string().required('Vui lòng chọn'),
});
